import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/privacy-policy/page.tsx")